import ReactGA from "react-ga4";

export const initGA = async (id) => {
    await ReactGA.initialize(id, { debug: true });
    await console.log(window.location.pathname);
    await ReactGA.send({ hitType: "pageview", page: window.location.pathname });
}